import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'

// Generic transitions
export const fadeInTransition = createSimpleTransition('fade-in-transition');

export default {
    fadeInTransition
}